import { CalendarFilled, EnvironmentFilled, StarFilled } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";

const { Title, Text } = Typography;

const KeyInfoSection = () => {
  return (
    <>
      <div style={{ width: "100%", background: "var(--neutral-alter)", padding: "50px 50px" }}>
        <Row style={{ maxWidth: "1200px", margin: "auto", color: "rgb(0, 0, 0, 0.8)" }} gutter={[32, 32]}>
          <Col md={8} sm={24} xs={24} style={{ textAlign: "center" }}>
            <CalendarFilled style={{ fontSize: "64px", paddingBottom: "10px" }} />
            <br />
            <Title level={3}>
              8.-11. <br /> SEPTEMBER
            </Title>
            <Text style={{ fontSize: "18px" }}>Messen vil avholdes 14.-16. september 2025</Text>
          </Col>
          <Col md={8} sm={24} xs={24} style={{ textAlign: "center" }}>
            <EnvironmentFilled style={{ fontSize: "64px", paddingBottom: "10px" }} />
            <br />
            <Title level={3}>
              NTNU <br /> GLØSHAUGEN
            </Title>
            <Text style={{ fontSize: "18px" }}>Sentralt plassert på plenen bak Hovedbygget</Text>
          </Col>
          <Col md={8} sm={24} xs={24} style={{ textAlign: "center" }}>
            <StarFilled style={{ fontSize: "64px", paddingBottom: "10px" }} />
            <br />
            <Title level={3}>
              Norges største <br /> karrieremesse
            </Title>
            <Text style={{ fontSize: "18px" }}>Over 15 000 besøkende studenter og 150 bedrifter i 2023</Text>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default KeyInfoSection;
